import { DataTable } from 'simple-datatables/dist/module';
import Mark from 'mark.js';
import JB from '../../scripts/JB';

const disclosuresSearch = {
  form: null,
  wrapper: null,
  searchInput: null,
  searchAutosuggest: null,
  autoSuggestApiUri: null,
  tags: null,
  selectList: null,
  searchResults: null,
  assetType: null,
  // table elements
  equityTableElement: null,
  morningStarTableElement: null,
  productTableElement: null,
  issuerTableElement: null,
  bondsTableElement: null,
  fundsTableElement: null,
  defaultTableOptions: {
    fixedColumns: false,
    searchable: false,
    perPage: 200,
    perPageSelect: false,
    labels: {
      info: '',
    },
  },

  init() {
    disclosuresSearch.dom();
    if (disclosuresSearch.wrapper === null) {
      return;
    }
    disclosuresSearch.bindEvents();
    disclosuresSearch.listenToEvents();
    disclosuresSearch.initSearch();
    disclosuresSearch.initTables();
    if (disclosuresSearch.searchInput !== null) {
      if (disclosuresSearch.searchFieldIsEmpty()) {
        window.dispatchEvent(new Event('disclosureSearchIsEmpty'));
      } else {
        window.dispatchEvent(new CustomEvent('disclosureSearchIsNotEmpty', { detail: { term: '' } }));
      }
    }
  },
  dom() {
    this.wrapper = document.querySelector('.module-form-disclosures-search');

    if (!this.wrapper) {
      return;
    }

    this.resultSearchInputWrap = this.wrapper.querySelector('.module-form-disclosures-search__input-wrap');
    this.form = this.wrapper.querySelector('form');
    this.searchInput = this.wrapper.querySelector('#search');
    this.typeInput = this.wrapper.querySelector('#type');
    this.tags = this.form.querySelectorAll('.module-form-disclosures-search__search-tags li');
    this.searchAutosuggest = this.form.querySelector('.module-form-disclosures-search__auto-suggest');
    this.autoSuggestApiUri = this.form.getAttribute('data-search-suggest-url');
    this.searchResults = document.querySelector('.o-disclosure-search-results');
    this.errorMsg = this.resultSearchInputWrap.querySelector('.error-msg');
    this.selectList = this.wrapper.querySelector('.select-list');
    this.styledSelectOptions = this.wrapper.querySelectorAll('.ss-dropdown .ss-option');
    this.disclosuresContainer = this.wrapper.querySelector('[data-disclosures-container] .m-richtext');

    // tables
    this.equityTableElement = document.getElementById('equityTable');
    this.morningStarTableElement = document.getElementById('morningStarTable');
    this.productTableElement = document.getElementById('productTable');
    this.issuerTableElement = document.getElementById('issuerTable');
    this.bondsTableElement = document.getElementById('bondsTable');
    this.fundsTableElement = document.getElementById('fundsTable');
  },
  bindEvents() {
    this.form.addEventListener('jb-button:clicked', async (e) => {
      if (e.detail.name === 'module-form-disclosures-search') {
        this.form.submit();
      }
    });
    disclosuresSearch.bindSearchElements();
  },
  listenToEvents() {
    window.addEventListener('disclosureSearchIsEmpty', () => {
      disclosuresSearch.hideElement(disclosuresSearch.searchAutosuggest);
    });

    window.addEventListener('disclosureSearchIsNotEmpty', (e) => {
      disclosuresSearch.doAutoSuggest(e.detail.term);
    });

    window.addEventListener('clearSearch', () => {
      disclosuresSearch.clearSearch();
      disclosuresSearch.clearAutoSuggest();
    });

    disclosuresSearch.form.addEventListener('submit', (e) => {
      if (!disclosuresSearch.inputIsValid(e)) {
        e.preventDefault();
        disclosuresSearch.errorMsg.classList.add('error');
        disclosuresSearch.showElement(disclosuresSearch.errorMsg);
      }
      disclosuresSearch.clearAutoSuggest();
    });

    this.selectList.addEventListener('change', (e) => {
      const option = e.target.options[e.target.selectedIndex];
      const { dataset } = option;
      const assetClass = option.value;
      disclosuresSearch.assetType = e.target.value;
      disclosuresSearch.clearError();
      disclosuresSearch.clearAutoSuggest();
      disclosuresSearch.hideElement(disclosuresSearch.searchResults);
      const generalDisclosures = dataset.generalDisclosures || '';
      const furtherDisclosures = dataset.furtherDisclosures || '';
      disclosuresSearch.errorMsg.innerHTML = dataset.error;
      disclosuresSearch.form.querySelector('label[for="search"]').innerHTML = dataset.label;
      disclosuresSearch.searchInput.placeholder = dataset.placeholder;
      disclosuresSearch.disclosuresContainer.innerHTML = generalDisclosures + furtherDisclosures;

      disclosuresSearch.form.setAttribute('data-search-suggest-url', dataset.searchSuggestUrl || '');
      disclosuresSearch.typeInput.value = assetClass;
      disclosuresSearch.searchInput.value = '';

      const activeTag = Array.from(disclosuresSearch.tags).find((tag) => tag.classList.hasModifier('active'));
      if (activeTag) {
        activeTag.classList.removeModifier('active');
      }
      const tagToActivate = Array.from(disclosuresSearch.tags).find((tag) => tag.dataset.type === assetClass);
      if (tagToActivate) {
        tagToActivate.classList.addModifier('active');
      }

      // append chosen type to current URL
      const url = new URL(window.location);
      url.hash = assetClass;
      window.location = url.toString();

      // append chosen type to form action URL
      let actionUrl = disclosuresSearch.form.getAttribute('action');
      if (actionUrl.indexOf('#') !== -1) {
        actionUrl = actionUrl.replace(/#.*/g, '#' + assetClass);
      } else {
        actionUrl += '#' + assetClass;
      }
      disclosuresSearch.form.setAttribute('action', actionUrl);
    }, false);

    this.tags.forEach((tag) => {
      tag.addEventListener('click', (e) => {
        e.preventDefault();
        const { dataset } = e.target.closest('li');
        Array.from(disclosuresSearch.styledSelectOptions).find((option) => option.dataset.value === dataset.type).click();
      }, false);
    });
  },
  inputIsValid() {
    if (disclosuresSearch.assetType === 'fixed-income-issuers') {
      return true;
    }
    return this.searchInput.value.length === 12;
  },
  bindSearchElements() {
    if (this.searchInput !== null) {
      this.searchInput.addEventListener('input', () => {
        if (disclosuresSearch.searchInput.value.trim().length === 0) {
          window.dispatchEvent(new Event('disclosureSearchIsEmpty'));
        } else {
          window.dispatchEvent(new CustomEvent('disclosureSearchIsNotEmpty', { detail: { term: disclosuresSearch.searchInput.value } }));
        }
      }, false);

      disclosuresSearch.searchInput.addEventListener('keydown', (e) => {
        const { keyCode } = e;
        const selectedChild = disclosuresSearch.searchAutosuggest.querySelector('.suggest--selected');

        // down = 40, up = 38
        if (keyCode === 40) {
          if (disclosuresSearch.searchAutosuggest.childNodes.length > 0) {
            if (selectedChild !== null) {
              if (selectedChild.nextSibling !== null) {
                selectedChild.classList.remove('suggest--selected');
                selectedChild.nextSibling.classList.add('suggest--selected');
                disclosuresSearch.searchInput.value = selectedChild.nextSibling.innerText;
              }
            } else {
              disclosuresSearch.searchAutosuggest.childNodes[0].classList.add('suggest--selected');
              disclosuresSearch.searchInput.value = disclosuresSearch.searchAutosuggest.childNodes[0].innerText;
            }
          }
        } else if (keyCode === 38) {
          if (disclosuresSearch.searchAutosuggest.childNodes.length > 0) {
            if (selectedChild !== null) {
              if (selectedChild.previousSibling !== null) {
                selectedChild.classList.remove('suggest--selected');
                selectedChild.previousSibling.classList.add('suggest--selected');
                disclosuresSearch.searchInput.value = selectedChild.previousSibling.innerText;
              } else {
                selectedChild.classList.remove('suggest--selected');
              }
            }
          }
        }
      }, false);
    }
  },
  doAutoSuggest(term) {
    disclosuresSearch.autoSuggestApiUri = disclosuresSearch.form.getAttribute('data-search-suggest-url');
    if (term && term.length > 2 && disclosuresSearch.autoSuggestApiUri !== '' && disclosuresSearch.autoSuggestApiUri !== null && disclosuresSearch.autoSuggestApiUri !== '/') {
      const url = disclosuresSearch.autoSuggestApiUri.replace('term', encodeURI(term));

      JB.getXMLHttpRequest(url, (response) => {
        if (response && !disclosuresSearch.searchFieldIsEmpty()) {
          disclosuresSearch.populateAutoSuggest(term, response);
        } else {
          disclosuresSearch.clearAutoSuggest();
        }
      });
    } else {
      disclosuresSearch.clearAutoSuggest();
    }
  },
  populateAutoSuggest(term, response) {
    disclosuresSearch.searchAutosuggest.innerHTML = '';

    if (Object.keys(response).length) {
      disclosuresSearch.showAutoSuggest();
    }

    Object.keys(response).forEach((item) => {
      const li = document.createElement('li');
      li.innerText = item;
      disclosuresSearch.searchAutosuggest.appendChild(li);

      li.addEventListener('click', function (e) {
        e.preventDefault();
        const selectedChild = disclosuresSearch.searchAutosuggest.querySelector('.suggest--selected');
        if (selectedChild !== null) {
          selectedChild.classList.remove('suggest--selected');
        }
        this.classList.add('suggest--selected');
        disclosuresSearch.searchInput.value = this.innerText;
        disclosuresSearch.form.submit();
      });
    });

    /* eslint-disable */
    const marky = new Mark(disclosuresSearch.searchAutosuggest);
    /* eslint-enable */
    marky.mark(term, {
      element: 'span',
    });
  },
  hideElement(el) {
    if (el !== null) {
      el.classList.add('hide');
      el.classList.remove('show');
    }
  },
  showElement(el) {
    if (el !== null) {
      el.classList.add('show');
      el.classList.remove('hide');
    }
  },
  searchFieldIsEmpty() {
    return this.searchInput.value.trim().length === 0;
  },
  showAutoSuggest() {
    disclosuresSearch.showElement(disclosuresSearch.searchAutosuggest);
    disclosuresSearch.searchAutosuggest.style.zIndex = '';
  },
  clearAutoSuggest() {
    if (disclosuresSearch.searchAutosuggest !== null) {
      disclosuresSearch.searchAutosuggest.innerHTML = '';
      disclosuresSearch.searchAutosuggest.style.zIndex = -1;
    }
  },
  clearSearch() {
    if (disclosuresSearch.searchInput !== null) {
      disclosuresSearch.searchInput.value = '';
      disclosuresSearch.searchInput.focus();
    }
  },
  clearError() {
    disclosuresSearch.hideElement(this.errorMsg);
    disclosuresSearch.errorMsg.classList.remove('error');
  },
  initSearch() {
    const url = new URL(window.location);
    if (url.hash) {
      const matchingTag = [...disclosuresSearch.tags].find((tag) => url.hash === '#' + tag.dataset.type);
      if (matchingTag) {
        const backupSearchValue = disclosuresSearch.searchInput.value;
        matchingTag.click();
        disclosuresSearch.searchInput.value = backupSearchValue;
        disclosuresSearch.showElement(disclosuresSearch.searchResults);
        return;
      }
    }
    disclosuresSearch.tags[0].click();
  },
  initTables() {
    if (disclosuresSearch.equityTableElement) {
      const options = disclosuresSearch.mergeWithDefaultTableConfig({
        columns: [
          {
            select: 2,
            sort: 'desc',
            type: 'date',
            format: 'YYYY-MM-DD',
          },
        ],
      });

      new DataTable(disclosuresSearch.equityTableElement, options);
    }

    if (disclosuresSearch.morningStarTableElement) {
      const options = disclosuresSearch.mergeWithDefaultTableConfig({
        columns: [
          {
            select: 6,
            sort: 'desc',
            type: 'date',
            format: 'YYYY-MM-DD',
          },
        ],
      });

      new DataTable(disclosuresSearch.morningStarTableElement, options);
    }

    if (disclosuresSearch.productTableElement) {
      const options = disclosuresSearch.mergeWithDefaultTableConfig({
        columns: [
          {
            select: 4,
            sort: 'desc',
            type: 'date',
            format: 'YYYY-MM-DD',
          },
        ],
      });

      new DataTable(disclosuresSearch.productTableElement, options);
    }

    if (disclosuresSearch.issuerTableElement) {
      const options = disclosuresSearch.mergeWithDefaultTableConfig({
        columns: [
          {
            select: 3,
            sort: 'desc',
            type: 'date',
            format: 'YYYY-MM-DD',
          },
        ],
      });

      new DataTable(disclosuresSearch.issuerTableElement, options);
    }

    if (disclosuresSearch.bondsTableElement) {
      const options = disclosuresSearch.mergeWithDefaultTableConfig({
        columns: [
          {
            select: 5,
            sort: 'desc',
            type: 'date',
            format: 'YYYY-MM-DD',
          },
          {
            select: 6,
            sort: 'desc',
            type: 'date',
            format: 'YYYY-MM-DD',
          },
        ],
      });

      new DataTable(disclosuresSearch.bondsTableElement, options);
    }

    if (disclosuresSearch.fundsTableElement) {
      const options = disclosuresSearch.mergeWithDefaultTableConfig({
        columns: [
          {
            select: 4,
            sort: 'desc',
            type: 'date',
            format: 'YYYY-MM-DD',
          },
        ],
      });

      new DataTable(disclosuresSearch.fundsTableElement, options);
    }
  },
  mergeWithDefaultTableConfig(config) {
    return Object.assign(config, disclosuresSearch.defaultTableOptions);
  },
};

export default disclosuresSearch;

// mocky URLS:
// default:  https://www.mocky.io//v2/5dc92a402f0000870073ea2d?query=term&L=2
// equities: https://www.mocky.io//v2/5dc935872f00007e0073eaa6?query=term&L=2
// fixed income issuers: https://www.mocky.io//v2/5dc938f02f0000560073eac7?query=term&L=2
// bonds: https://www.mocky.io//v2/5dc939812f0000690073eacf?query=term&L=2
// funds: https://www.mocky.io//v2/5dc939e62f00007e0073ead1?query=term&L=2
// structured products:  https://www.mocky.io//v2/5dc93aba2f0000680073ead8?query=term&L=2
